module.exports = __webpack_public_path__ + "img/Rectangle_37.ec993b52.svg";